define('modules/includes_editor/views/editor_modal',['require','exports','module','common/views/modal_view','cm/lib/codemirror','cm/mode/htmlmixed/htmlmixed','ldsh!../templates/editor_modal'],function (require, exports, module){
  "use strict";
  var ModalView = require("common/views/modal_view"),
      CodeMirror = require("cm/lib/codemirror"),
      cmhtmlmixed = require("cm/mode/htmlmixed/htmlmixed");

  module.exports = ModalView.extend({
    template: require("ldsh!../templates/editor_modal"),
    events: {
      "click .js-save": "saveContent",
      "click .js-close": "closeEditor"
    },
    initialize: function(options){
      this.content = options.content || "";
    },

    saveContent: function(e){
      e.preventDefault();
      this.content = this.codeEditor.getValue();
      this.trigger("modal:save", this.content);
    },

    closeEditor: function(e){
      e.preventDefault();
      this.hide();
    },
    onRender: function(){
      this.$el.i18n();
    },
    onModalShown: function(){
      if(this.codeEditor) return;
      var editorDomElement = document.getElementById("htmlEditor");
      this.codeEditor = CodeMirror.fromTextArea(editorDomElement,
        {
          mode: "htmlmixed",
          lineNumbers: true,
          autoFocus: true,
          lineWrapping: true
        });
      this.codeEditor.setValue(this.content);
    },

    onClose: function(){

    }
  });
});

